<template>
  <div>
    <section id="top-bar">
      <div class="container">
        <div class="row">
          <div class="col">Halaman lupa kata sandi</div>
          <div class="col">
            <div class="text-right bread">
              <i class="fas fa-home"></i> Beranda &gt; Recovery
            </div>
          </div>
        </div>
      </div>
    </section>
    <section id="content" class="mt-4 mb-4">
      <div class="container">
        <div class="row">
          <div class="col-md-5 offset-md-3">
            <h2>Lupa kata sandi?</h2>
            <template v-if="$store.state.messageRecovery == ''">
              <div
                v-if="$store.state.messageRecoveryError != ''"
                class="alert alert-warning"
              >
                {{ $store.state.messageRecoveryError }}
              </div>
            </template>
            <template v-else>
              <div
                v-if="$store.state.messageRecovery != ''"
                class="alert alert-success"
              >
                {{ $store.state.messageRecovery }}
              </div>
            </template>
            <p class="mb-3">
              Masukan email yang terdaftar pada situs ini, kami akan mengirimkan
              tautan untuk memperbaharui kata sandi.
            </p>
            <form
              @submit.prevent="submit()"
              class="margin-lg-top"
              method="post"
              accept-charset="utf-8"
            >
              <div class="form-group">
                <input
                  v-model="email"
                  type="email"
                  class="form-control"
                  placeholder="Email"
                  required
                />
              </div>

              <!-- reCAPTCHA (will render when grecaptcha script loads) -->
              <div class="form-group" ref="recaptchaContainer">
                <div ref="recaptcha"></div>
                <div v-if="recaptchaAvailable && !captchaToken" class="text-muted small">
                  Silakan selesaikan reCAPTCHA sebelum mengirim.
                </div>
              </div>

              <div class="form-group">
                <button
                  v-if="!$store.state.loadPage"
                  :disabled="recaptchaAvailable && !captchaToken"
                  type="submit"
                  id="btn-submit-login"
                  class="btn btn-primary register-submit"
                >
                  Kirim
                  <i class="fas fa-paper-plane"></i>
                </button>
                <button
                  v-else
                  type="button"
                  class="btn btn-primary register-submit"
                >
                  Tunggu sebentar..
                </button>
              </div>
            </form>
            <div>
              Sudah punya akun?
              <router-link to="/login">
                <a>Masuk disini</a>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  data() {
    return {
      email: "",
      source: "platform",
      captchaToken: "",
      recaptchaWidgetId: null,
      recaptchaAvailable: false
    };
  },
  methods: {
    ...mapActions(["recoveryAccount"]),
    submit() {
      const payload = { email: this.email, token: this.captchaToken || "" };
      // recoveryAccount now returns a Promise
      this.recoveryAccount(payload)
        .finally(() => {
          // reset form and reCAPTCHA (if available)
          if (window.grecaptcha && this.recaptchaWidgetId !== null) {
            window.grecaptcha.reset(this.recaptchaWidgetId);
          }
          this.captchaToken = "";
          this.email = "";
        });
    },
    renderRecaptcha() {
      // already rendered
      if (this.recaptchaWidgetId !== null) return;

      const tryRender = () => {
        if (window.grecaptcha && typeof window.grecaptcha.render === "function") {
          try {
            this.recaptchaWidgetId = window.grecaptcha.render(this.$refs.recaptcha, {
              sitekey: "6LfRj50pAAAAALsIA_D8C30oGAJoU6ji3cPqJ_vH",
              callback: (token) => {
                this.captchaToken = token;
              },
              "expired-callback": () => {
                this.captchaToken = "";
              },
            });
            this.recaptchaAvailable = true;
            return true;
          } catch (err) {
            console.warn("reCAPTCHA: render() threw —", err);
            return false;
          }
        }
        return false;
      };

      // immediate attempt
      if (tryRender()) return;

      // if grecaptcha provides ready(), use it
      if (window.grecaptcha && typeof window.grecaptcha.ready === "function") {
        try {
          window.grecaptcha.ready(() => {
            tryRender();
          });
          return;
        } catch (e) {
          // fall through to polling
        }
      }

      // fallback: poll a few times for render to become available
      let attempts = 0;
      const maxAttempts = 25; // ~5s
      const intervalId = setInterval(() => {
        attempts += 1;
        if (tryRender() || attempts >= maxAttempts) {
          clearInterval(intervalId);
          if (attempts >= maxAttempts && !this.recaptchaAvailable) {
            console.warn("reCAPTCHA: render() not available after waiting; widget will not be shown.");
          }
        }
      }, 200);
    }
  },
  mounted() {
    // load reCAPTCHA script if not present; request explicit render to ensure API exposes `render`
    if (!window.grecaptcha) {
      const script = document.createElement("script");
      script.src = "https://www.google.com/recaptcha/api.js?render=explicit&hl=id";
      script.async = true;
      script.defer = true;
      script.onload = () => this.renderRecaptcha();
      script.onerror = () => console.warn("Failed to load reCAPTCHA script");
      document.head.appendChild(script);
    } else {
      // grecaptcha exists but may not have render(); renderRecaptcha() will handle that case safely
      this.renderRecaptcha();
    }
  },
  created() {
    this.$store.state.messageRecovery = "";
    this.$store.state.messageRecoveryError = "";
  },
};
</script>
